import { createAuth0Instance } from '@/helpers/Auth/authClient';
import { AXIOS_HEADERS } from '@/types';
import { getAxios } from '@smg-real-estate/hg-networking';
import { Axios, AxiosHeaders, InternalAxiosRequestConfig } from 'axios';

export const createHeaders = (init?: Record<string, string>): AxiosHeaders => {
  const headers = new AxiosHeaders();
  if (init) headers.set(init);
  return headers;
};

export const getAxiosClient = (customHeaders?: AxiosHeaders): Axios => {
  const axios = getAxios();
  const auth0Instance = createAuth0Instance();

  axios.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
    if (customHeaders) {
      config.headers.set(customHeaders);
    }

    config.headers[AXIOS_HEADERS.API_KEY] = import.meta.env.VUE_APP_VALUATION_SERVICE_API_KEY ?? '';
    // x-e2e-test header was used to skip OTP SMS in property valuation service.
    // OTP steps have been removed for now, so this header is not needed.
    // config.headers[AXIOS_HEADERS.E2E_TEST_HEADER] = import.meta.env.VUE_APP_STAGE !== 'prod';

    if (auth0Instance) {
      const { getAccessTokenSilently, isAuthenticated } = auth0Instance;
      if (!isAuthenticated.value) {
        return config;
      }

      const accessToken = await getAccessTokenSilently();
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
    }

    return config;
  });

  return axios;
};
